import Header from '@ClientPortal/components/common/Header.vue';
import Footer from '@ClientPortal/components/common/Footer.vue';
import VerticalHeader from '@Common/VerticalHeader.vue';

const securityProfiles = "prod,security-okta".split(",") // process.env.SECURITY_PROFILE.split(",")

//Main Tabs
const HomePage = resolve => {
    require.ensure(['@ClientPortal/components/pages/home/HomePage.vue'], () => {
        resolve(require('@ClientPortal/components/pages/home/HomePage.vue'))
    }, 'HomePage');
}

const CasesIndex = resolve => {
    require.ensure(['@ClientPortal/components/pages/cases/CasesIndex.vue'], () => {
        resolve(require('@ClientPortal/components/pages/cases/CasesIndex.vue'))
    }, 'Cases');
}

const Settlements = resolve => {
    require.ensure(['@ClientPortal/components/pages/settlements/SettlementsIndex.vue'], () => {
        resolve(require('@ClientPortal/components/pages/settlements/SettlementsIndex.vue'))
    }, 'Settlements');
}

const ReposeTracker = resolve => {
    require.ensure(['@ClientPortal/components/pages/reposeTracker/ReposeTracker.vue'], () => {
        resolve(require('@ClientPortal/components/pages/reposeTracker/ReposeTracker.vue'))
    }, 'ReposeTracker');
}

const Reports = resolve => {
    require.ensure(['@ClientPortal/components/pages/reports/Reports.vue'], () => {
        resolve(require('@ClientPortal/components/pages/reports/Reports.vue'))
    }, 'Reports');
}

const RecoverMax = resolve => {
    require.ensure(['@ClientPortal/components/pages/recoverMax/RecoverMax.vue'], () => {
        resolve(require('@ClientPortal/components/pages/recoverMax/RecoverMax.vue'))
    }, 'RecoverMax');
}

const LossRuns = resolve => {
    require.ensure(['@ClientPortal/components/pages/lossReport/LossRuns.vue'], () => {
        resolve(require('@ClientPortal/components/pages/lossReport/LossRuns.vue'))
    }, 'LossRuns');
}

const LossCalculator = resolve => {
    require.ensure(['@ClientPortal/components/pages/lossReport/LossCalculator.vue'], () => {
        resolve(require('@ClientPortal/components/pages/lossReport/LossCalculator.vue'))
    }, 'LossCalculator');
}

const LossOverviewDisplay = resolve => {
    require.ensure(['./components/pages/lossReport/LossOverviewDisplay.vue'], () => {
        resolve(require('./components/pages/lossReport/LossOverviewDisplay.vue'))
    }, 'LossOverviewDisplay')
}

//Sub Pages
const ClientPortalCases = resolve => {
    require.ensure(['@ClientPortal/components/pages/clientPortalCase/Case.vue'], () => {
        resolve(require('@ClientPortal/components/pages/clientPortalCase/Case.vue'))
    }, 'ClientPortalCases');
}

const UserProfile = resolve => {
    require.ensure(['@ClientPortal/components/UserProfile.vue'], () => {
        resolve(require('@ClientPortal/components/UserProfile.vue'))
    }, 'UserProfile')
}


const LossReport = resolve => {
    require.ensure(['@ClientPortal/components/pages/lossReport/LossReport.vue'], () => {
        resolve(require('@ClientPortal/components/pages/lossReport/LossReport.vue'))
    }, 'LossReport')
}

//Functionality Routes
const Forbidden = resolve => {
    require.ensure(['../components/Forbidden.vue'], () => {
        resolve(require('../components/Forbidden.vue'))
    }, 'Forbidden')
}

const ClientLogin = resolve => {
    require.ensure(['@ClientPortal/components/ClientLogin.vue'], () => {
        resolve(require('@ClientPortal/components/ClientLogin.vue'))
    }, 'ClientLogin')
}

const OktaLogin = resolve => {
    require.ensure(['@ClientPortal/components/OktaLogin.vue'], () => {
        resolve(require('@ClientPortal/components/OktaLogin.vue'))
    }, 'OktaLogin')
}

const PageNotFound = resolve => {
    require.ensure(['../components/PageNotFound.vue'], () => {
        resolve(require('../components/PageNotFound.vue'))
    }, 'PageNotFound')
}

export const routes = [
    {
        path: '/',
        name: 'Home Page',
        components: {
            default: HomePage,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/cases',
        name: 'Cases',
        components: {
            default: CasesIndex,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settlements',
        name: 'Settlements',
        components: {
            default: Settlements,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reposeTracker',
        name: 'Repose Tracker',
        components: {
            default: ReposeTracker,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        components: {
            default: Reports,
            'header-top': Header,
            'footer': Footer
        },   
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/recoverMax',
        name: 'RecoverMax',
        components: {
            default: RecoverMax,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lossCalculator',
        name: 'Loss Calculator',
        components: {
            default: LossCalculator,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lossCalc',
        name: 'Loss Calculator',
        components: {
            default: LossCalculator,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lossRuns',
        name: 'Loss Runs',
        components: {
            default: LossRuns,
            'header-top': Header,
            'header-vertical': VerticalHeader,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lossOverview',
        name: 'Loss Overview',
        components: {
            default: LossOverviewDisplay,
            'header-top': Header,
            'header-vertical': VerticalHeader
            //'side-menu': SideMenu
        },
        meta:{
            requiresAuth: true
        }
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        components: {
            default: Forbidden,
        }
    },
    {
        path: '/login',
        name: 'Login Page',
        components: {
            default: securityProfiles.includes('security-okta') ? OktaLogin : ClientLogin
        },
        meta: {
            doesNotRequireLogin: true,
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        components: {
            default: UserProfile,
            'header-top': Header,
            'footer': Footer
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/cases/case/:caseId',
        name: 'Case',
        components: {
            default: ClientPortalCases,
            'header-top': Header, 
            'footer': Footer,
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/cases/case/:caseId/:caseSection',
        name: 'Case',
        components: {
            default: ClientPortalCases,
            'header-top': Header,
            'footer': Footer,
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lossReport',
        name: 'Loss Report',
        components: {
            default: LossReport,
            'header-top': Header,
            'footer': Footer
        },
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    //Logout
    {
        path: '/pageNotFound',
        name: 'Page Not Found',
        components: {
            default: PageNotFound,
        }
    },
    {
        path: '*',
        redirect: '/pageNotFound'
    }
];
